// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.ds.DataSource
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { AbstractClientRequestContext } from "abweb/dto/ds/AbstractClientRequestContext";
import { AbstractDataSource } from "abweb/dto/ds/AbstractDataSource";
import { DataSourceRecord } from "abweb/dto/ds/DataSourceRecord";
import { DataSourceRecordFormat } from "abweb/dto/ds/DataSourceRecordFormat";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class DataSourceBase extends AbstractDataSource {
  /** Do NOT invoke directly, instead use strongly typed createDataSourceBase factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadd.DataSource";
  }
  initFromJson(json, deserializeContext) {
    this.initDataSource(json.argumentValues != null ? json.argumentValues : null, TSOGUtils.decodeObject(json.clientRequestContext, AbstractClientRequestContext, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "clientRequestContext")), json.id != null ? json.id : null, json.hierarchical != null ? json.hierarchical : null, TSOGUtils.decodeObject(json.recordFormat, DataSourceRecordFormat, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "recordFormat")), json.records != null ? TSOGUtils.decodeObjectArray(json.records, DataSourceRecord, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "records")) : null);
  }
  initDataSource(argumentValues, clientRequestContext, id, hierarchical, recordFormat, records) {
    this.initAbstractDataSource(argumentValues, clientRequestContext, id);
    this._hierarchical = hierarchical;
    this._recordFormat = recordFormat;
    this._records = records;
  }
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    retVal["hierarchical"] = this._hierarchical;
    retVal["recordFormat"] = TSOGUtils.toTSOGNativeObject(this._recordFormat, serializeContext);
    retVal["records"] = TSOGUtils.toTSOGArray(this._records, serializeContext);
    return retVal;
  }
  get hierarchical() {
    return this._hierarchical;
  }
  set hierarchical(value) {
    this._hierarchical = value;
  }
  get recordFormat() {
    return this._recordFormat;
  }
  set recordFormat(value) {
    this._recordFormat = value;
  }
  get records() {
    return this._records;
  }
  set records(value) {
    this._records = value;
  }
}
//# sourceMappingURL=DataSourceBase.js.map
